import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SignProposalPage from './SignProposalPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Public, unauthenticated proposal-signing route. Everything else is the app.
const isSignRoute = window.location.pathname.replace(/\/+$/,'').endsWith('/sign');
root.render(isSignRoute ? <SignProposalPage /> : <App />);

// Register Service Worker for offline support (PWA)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // Listen for SW messages (e.g., background sync ready)
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'SYNC_REQUESTED') {
            window.dispatchEvent(new CustomEvent('ts-cloud-sync'));
          }
        });
        // Periodically check for SW updates
        setInterval(() => reg.update(), 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}
